<template>
  <div>
    <section>
      <v-card class="transparent elevation-2">
        <v-container container--fluid pb-0>
          <v-card-title>
            <h1>Invoices</h1>
          </v-card-title>
          <v-card-actions>
            <v-row justify="space-between" no-gutters :class="{'flex-column': $vuetify.breakpoint.smAndDown}">
              <v-col cols="12" md="4">
                <v-text-field
                  v-model="search"
                  label="Search..."
                  prepend-icon="fas fa-search"
                  clearable
                >
                </v-text-field>
              </v-col>
              <v-col cols="12" md="2">
                <v-switch
                  class="justify-center"
                  color="blue"
                  v-model="closedSwitch"
                  :label="closedSwitch ? 'Closed Invoices' : 'Open Invoices'"
                  @change="keyDataTable++"
                ></v-switch>
              </v-col>
            </v-row>
          </v-card-actions>
          <!--<v-col>-->
          <!--<v-text-field-->
          <!--v-model="search"-->
          <!--label="Search"-->
          <!--single-line-->
          <!--hide-details-->
          <!--append-icon="fas fa-search"-->
          <!--&gt;</v-text-field>-->
          <!--</v-col>-->
          <v-dialog v-model="invoiceDialog" width="500px">
            <template v-slot:activator="{ on }">
              <v-menu bottom float-left>
                <template v-slot:activator="{ on }">
                  <v-btn dark color="blue lighten-1" fab bottom absolute right v-on="on">
                    <v-icon>add</v-icon>
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item v-on="on" @click="editedInvoice = Object.assign({}, defaultInvoice)">
                    <v-list-item-title>Create a new invoice</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </template>
            <v-card>
              <v-card-title>
                <h2>{{dialogTitle}}</h2>
              </v-card-title>

              <v-divider color="#42a5f5"></v-divider>

              <v-card-text>
                <v-container>
                  <v-row dense>
                    <v-col cols="12">
                      <v-autocomplete
                        v-model="editedInvoice.client"
                        return-object
                        :items="clients"
                        label="Client Name"
                        item-value="name"
                        item-text="name"
                      ></v-autocomplete>
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col cols="12" v-if="editedIndex !== -1">
                      <v-select v-model="editedInvoice.state" :items="states" label="State"></v-select>
                    </v-col>
                    <v-col cols="12" v-if="editedIndex !== -1">
                      <v-text-field v-model="editedInvoice.postcode" label="Postcode"
                                    :mask="postcodeMask">
                      </v-text-field>
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col cols="12">
                      <v-menu
                        v-model="dateMenu"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        min-width="100px">
                        <template v-slot:activator="{ on }">
                          <v-text-field
                            v-model="editedInvoice.date"
                            label="Date"
                            clearable
                            readonly
                            v-on="on"
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          v-model="editedInvoice.date"
                          @input="dateMenu=false"
                        ></v-date-picker>
                      </v-menu>
                    </v-col>
                  </v-row>

                </v-container>
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn text color="blue-grey lighten-2" @click="cancel">Cancel</v-btn>
                <v-btn text color="blue darken-1" @click="save">Save</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>

        </v-container>
      </v-card>
    </section>

    <v-divider color="#42a5f5"></v-divider>

    <section>
      <v-data-table
        :key="keyDataTable"
        :headers="headers"
        :items="renderedInvoices"
        item-key="id"
        :loading="searching"
        :search="search"
        :expanded="expanded"
        show-expand
      >
        <template v-slot:item="props">
          <tr class="cursor" v-bind:class="{odd: props.index % 2, even: !props.index % 2}">
            <td style="text-align: right">
              <div v-if="!editArray[invoicesId.indexOf(props.item.id)]">{{props.item.id}}</div>
              <div v-else>
                <v-text-field></v-text-field>
              </div>
            </td>
            <td style="text-align: center">{{props.item.client_name}}</td>
            <td style="text-align: center">{{props.item.state}}
            </td>
            <td style="text-align: center">{{props.item.postcode}}
            </td>
            <td style="text-align: center">{{props.item.date}}
            </td>
            <!--<td style="text-align: center">{{ props.item.stops_total }}</td>-->
            <td style="text-align: center">
              ${{formatPrice(props.item.total)}}
            </td>
            <td class="justify-center layout px-0" v-if="editPermission">
              <v-icon
                small
                class="px-3"
                :color="props.item.closed ? 'grey' : 'blue'"
                @click="toggleExpand(props.item);editInvoice(props)"
                :disabled="props.item.closed ? true:false"
              >
                edit
              </v-icon>
              <v-icon
                small
                class="px-3"
                @click="displayDeleteMessage(props.item)"
                color="red"
                :disabled="props.item.closed ? true:false"
              >
                fas fa-trash
              </v-icon>
            </td>
            <td>
              <v-icon small @click="toggleExpand(props.item);invoiceSelected(props)">
                {{props.item.expanded ? 'fas fa-chevron-up': 'fas fa-chevron-down'}}
              </v-icon>
            </td>
          </tr>
        </template>

        <template v-slot:expanded-item="props">
          <td :colspan="headers.length" class="px-0">
            <v-card>
              <v-card-title class="justify-center">
                <h2>Information</h2>
              </v-card-title>
              <v-divider></v-divider>
              <v-card-text>
                <v-row justify="space-around" align="center" no-gutters>
                  <v-col cols="12" md="6"
                         v-for="(field, index) in Object.keys(props.item)"
                         v-if="field !== 'closed' && field !== 'deleted'"
                         :key="index"
                  >
                    <v-row justify="center" align="center">
                      <v-col cols="10" md="4" class="raleway-bold" :class="{'text-center pb-0': $vuetify.breakpoint.smAndDown}">
                        {{fields[field]}}
                      </v-col>
                      <v-col cols="8" class="text-center" :class="{'pt-1': $vuetify.breakpoint.smAndDown}"
                             v-if="!editInvoiceInfo || field==='id' || field==='line_total'
                                                    || field==='total' || field==='gst' || field==='client_id'"
                      >
                        {{Object.values(props.item)[index]}}
                      </v-col>
                      <v-col v-else cols="10" md="8" style="text-align: center" >
                        <div
                          v-if="[
                                                'abn',
                                                'postcode',
                                                'oracle_site_number',
                                                'date',
                                                'discount',
                                                'gst',
                                                'phone',
                                                'oracle_account_number',
                                                'due'].includes(field)">
                          <input
                            style="text-align: center"
                            v-model="editedInvoice[field]"
                            oninput="this.value = this.value.replace(/[^0-9() .-]/g, '').replace(/(\..*)\./g, '$1');"
                          >
                        </div>
                        <!--<div v-if="field==='discount'">-->
                        <!--<input-->
                        <!--style="text-align: center"-->
                        <!--v-model="editedInvoice[field]"-->
                        <!--type="number"-->
                        <!--min="0.01"-->
                        <!--max="99.99"-->
                        <!--&gt;-->
                        <!--</div>-->
                        <div v-else>
                          <input
                            style="text-align: center"
                            v-model="editedInvoice[field]">
                        </div>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>

                <v-row v-if="!editInvoiceInfo" justify="space-around" align="center" :class="{'flex-column': $vuetify.breakpoint.smAndDown}">
                  <v-col cols="12" md="3" style="text-align: center">
                    <v-btn text color="warning" @click="invoiceDisplayerDialog=true">
                      <v-icon class="mr-2">fas fa-list-ul</v-icon>
                      Display Invoice
                    </v-btn>
                  </v-col>
                  <v-col cols="12" md="3" style="text-align: center">
                    <v-btn text dark color="indigo" @click="displayPdfInvoice(props.item)" :loading="loadingPreview">
                      <v-icon class="mr-2">fas fa-eye</v-icon>
                      Invoice Preview
                    </v-btn>
                  </v-col>
                  <v-col cols="12" md="3" style="text-align: center" v-if="!props.item.closed && editPermission">
                    <v-btn text color="green" dark @click="displayCloseMessage(props.item)"
                           :loading="loadingClose">
                      <v-icon class="mr-2">fas fa-paper-plane</v-icon>
                      Close Invoice
                    </v-btn>
                  </v-col>
                  <v-col cols="12" md="3" style="text-align: center" v-if="props.item.closed">
                    <v-btn text color="blue darken-1"  @click="csvExport(props.item.id)">
                      <v-icon class="mr-2">fas fa-file-export</v-icon>
                      Export CSV
                    </v-btn>
                  </v-col>
                  <v-col cols="12" md="3" style="text-align: center" v-if="props.item.closed">
                    <v-btn text color="red darken-2" @click="downloadPdfInvoice(props.item)" :loading="loadingDownload">
                      <v-icon class="mr-2">fas fa-file-pdf</v-icon>
                      Download Pdf
                    </v-btn>
                  </v-col>
                </v-row>

                <v-row v-else justify="center" align="center" :class="{'flex-column': $vuetify.breakpoint.smAndDown}">
                  <v-col cols="12" md="3" style="text-align: center">
                    <v-btn text color="red" @click="cancel">Cancel</v-btn>
                  </v-col>
                  <v-col cols="12" md="3" style="text-align: center">
                    <v-btn text color="primary" @click="save()">Save</v-btn>
                  </v-col>
                </v-row>

                <v-dialog v-model="invoiceDisplayerDialog" fullscreen hide-overlay
                          transition="dialog-bottom-transition">
                  <InvoiceDisplayer
                    :edit="editPermission"
                    v-if="invoiceDisplayerDialog"
                    :toggle-dialog="toggleInvoiceDialog"
                    :invoice-info="invoiceInformation"
                    :regions="regions"
                  ></InvoiceDisplayer>
                </v-dialog>

                <v-divider></v-divider>

                <CreditNoteTable v-if="creditNoteInformation && invoiceInformation"
                                 :create-button="closedSwitch"
                                 v-on:add="raiseCreditNote"
                                 v-on:update-credit-note-table="getCreditCardInfo(invoiceInformation.id)"
                                 :edit-permission="editPermission"
                                 :regions="regions"
                                 :closed-invoice="invoiceInformation.closed"
                                 :credit-note-information="creditNoteInformation"
                                 :action-disable="!invoiceInformation.closed"
                                 @refresh-data="getCreditCardInfo"
                ></CreditNoteTable>
              </v-card-text>
            </v-card>
          </td>
        </template>

      </v-data-table>
    </section>

    <v-dialog v-model="creditNoteDialog" width="400px">
      <v-card>
        <v-card-title>
          <h3>Raise a credit note</h3>
        </v-card-title>
        <v-divider color="#42a5f5"></v-divider>
        <v-card-text>
          <v-container>
            <v-text-field
              type="number"
              v-model="creditAmount"
              label="Credit Amount..."
              prefix="$"
            ></v-text-field>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="creditNoteDialog=false">Cancel</v-btn>
          <v-btn @click="" color="blue darken-1">OK</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="confirmDialog"
      max-width="500px"
    >
      <v-card>
        <v-card-title class="justify-center">
          <h3>ATTENTION</h3>
        </v-card-title>
        <v-card-text class="text-center">
          Are you sure you want to delete this item ?<br>
          This action cannot be reversed.
        </v-card-text>
        <v-card-actions class="justify-center">
          <v-btn text color="blue-grey lighten-2" @click="confirmDialog=false">No</v-btn>
          <v-btn text color="blue darken-1" @click="deleteInvoice()">Yes</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="confirmCloseDialog"
      max-width="500px"
    >
      <v-card>
        <v-card-title>
          Do you want to send this invoice after you closed it ?
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12">
              If so, to what email ? (If different from your default one)
              <v-text-field
                :rules="emailRules"
                prepend-icon="mail"
                v-model="emailTo"
                label="Email Address..."
              >
              </v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="justify-center">
          <v-btn color="red" text @click="confirmCloseDialog=false; emailTo=''">Cancel</v-btn>
          <v-btn text @click="closeInvoice('no')">No</v-btn>
          <v-btn color="blue darken-1" text @click="closeInvoice('yes')">Yes</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </div>
</template>

<script>
    import InvoiceDisplayer from "./InvoiceDisplayer";
    import axios from 'axios'
    import CreditNoteTable from "./CreditNoteTable";

    // @vuese
    // Table of all the invoices
    // @group Invoices
    export default {
        name: "InvoicesDataTable",
        components: {CreditNoteTable, InvoiceDisplayer},
        props: {
            invoices: Array,
            totalInvoices: Number,
            editArray: Array,
            searching: Boolean,
            displayMessage: Function,
        },
        data() {
            return {
                expanded: [],
                search: '',
                invoiceDialog: false,
                invoiceInformation: null,
                closedInvoices: [],
                openedInvoices: [],
                closedSwitch: false,
                invoiceDisplayerDialog: false,
                editedInvoice: {
                    id: 0,
                    client_name: '',
                    state: '',
                    postcode: '',
                    due: '',
                    total: '',
                    closed: false
                },
                defaultInvoice: {
                    id: 0,
                    client_name: '',
                    state: '',
                    postcode: '',
                    due: '',
                    total: '',
                    closed: false
                },
                editedIndex: -1,
                postcodeMask: '####',
                states: [
                    'NSW',
                    'WA',
                    'SA',
                    'QLD',
                    'VIC',
                    'TAS'
                ],
                dateMenu: false,
                confirmDialog: false,
                confirmation: false,
                actionOver: false,
                loadingPreview: false,
                loadingDownload: false,
                loadingDisplay: false,
                loadingClose: false,
                toBeDeleted: null,
                editInvoiceInfo: false,
                confirmCloseDialog: false,
                keyDataTable: 0,
                emailTo: null,
                emailRules: [],
                hintVisible: false,
                fields: {
                    id: 'ID',
                    client_name: 'Client Name',
                    abn: 'ABN',
                    suburb: 'Suburb',
                    postcode: 'Postcode',
                    email: 'Email',
                    oracle_site_number: 'Oracle Site Number',
                    date: 'Date',
                    discount: 'Discount (%)',
                    gst: 'GST',
                    client_id: 'Client ID',
                    legal_name: 'Legal Name',
                    address: 'Address',
                    state: 'State',
                    phone: 'Phone',
                    oracle_account_number: 'Oracle Account Number',
                    payment_terms: 'Payment Terms',
                    due: 'Due Date',
                    line_total: 'Line Total',
                    total: 'Total'
                },
                creditNoteDialog: false,
                creditAmount: null,
                creditNoteInformation: [],
            }
        },
        watch: {
            emailTo: function (mail) { // emailTo is the exact name used in v-model
                if (mail !== '' && mail !== null) {
                    this.emailRules = [v => (v.match(/^(([a-zA-Z0-9_\-\.]+)@([a-zA-Z0-9_\-\.]+)\.([a-zA-Z]{2,5}){1,25})+([,.](([a-zA-Z0-9_\-\.]+)@([a-zA-Z0-9_\-\.]+)\.([a-zA-Z]{2,5}){1,25})+)*$/)) || 'Invalid Email address (Don \'t put space after the coma if multiple addresses)']
                } else if (mail === '') {
                    this.emailRules = []
                }
            },
        },

        computed: {
            pages() {
                if (this.pagination.rowsPerPage == null ||
                    this.pagination.totalItems == null
                ) {
                    return 0
                }

                return Math.ceil(this.pagination.totalItems / this.pagination.rowsPerPage)
            },
            invoicesId() {
                return this.invoices.map((elt) => {
                    return elt.id
                })
            },
            dialogTitle() {
                return this.editedIndex > -1 ? 'Edit Invoice ' + this.editedInvoice.id : 'New Invoice'
            },
            renderedInvoices() {
                return this.invoices.filter((elt) => {
                    return elt.closed === this.closedSwitch
                })
            },
            editPermission() {
                return this.$store.getters['auth/hasPermission']('invoice_edit');
            },
            regions() {
                return this.$store.state.auth.regions;
            },
            headers() {
                let headers = [
                    {text: 'Id', value: 'id', align: 'center', sortable: true, width: '5%'},
                    {text: 'Client Name', value: 'client_name', align: 'center', sortable: true},
                    {text: 'State', value: 'state', align: 'center', sortable: false},
                    {text: 'Postcode', value: 'postcode', align: 'center', sortable: false},
                    {text: 'Invoice Date', value: 'date', align: 'center', sortable: false},
                    {text: 'Total', value: 'total', align: 'center', sortable: true},

                ];
                if (this.editPermission) {
                    headers.push({text: 'Actions', align: 'center', sortable: false});
                }
                headers.push({text: '', value: 'data-table-expand'});
                return headers;
            }
        },
        asyncComputed: {
            async clients() {
                return await axios.get(process.env.API_URL + '/clients?inactive=' + true)
                    .then((response) => {
                        return Object.values(response.data).sort((a, b) => (a.name > b.name) ? 1 : -1);
                    })
                    .catch((error) => {
                        return [];
                    })
            }
        },
        methods: {
            // @vuese
            // Raise an empty credit note
            raiseCreditNote() {
                if (this.invoiceInformation === null || this.invoiceInformation === undefined) {
                    this.displayMessage('An error has occured please click again on the row you want to add a credit note to');
                } else {
                    axios.post(process.env.API_URL + '/invoices/' + this.invoiceInformation.id + '/creditnotes')
                        .then((response) => {
                            this.$store.commit('displaySnackbar', 'Credit Note raised on invoice Nº ' + this.invoiceInformation.id);
                            this.creditNoteInformation.unshift(response.data);
                        })
                        .catch((response) => {
                            this.displayMessage('ERROR ' + response.response.data.error);
                        })
                }
            },
            // @vuese
            // Exports invoice csv file and downloads it
            csvExport(id) {
                window.open(process.env.API_URL + '/invoices/' + id + '/csv?key=' + encodeURI(this.$store.state.auth.key), '_blank');
            },
            formatPrice(value) {
                let val = (value / 1).toFixed(2).replace('.', ',');
                return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
            },
            // @vuese
            // Saves the changes made in the invoices table whether they are editing or even adding a new line,
            // resets then all the relevant variables to default values.
            save() {
                if (this.editedIndex > -1) {
                    // this.editedInvoice.discount = this.editedInvoice.discount / 100;
                    axios.put(process.env.API_URL + '/invoices/' + this.editedInvoice.id, this.editedInvoice)
                        .then((response) => {
                            if (response.status === 200) {
                                Object.assign(this.invoices[this.editedIndex], response.data);
                                this.invoiceDialog = false;
                                this.editInvoiceInfo = false;
                                this.$store.commit('displaySnackbar', 'Invoice Nº' + response.data.id + ' modified.');
                            } else {
                                this.displayMessage('ERROR ' + response.status);
                            }
                        })
                        .catch((error) => {
                            this.displayMessage('ERROR ' + error.response.status + '. ' + error.response.data.error)
                        })
                } else {
                    delete this.editedInvoice.id;
                    let body = {};
                    if (this.editedInvoice.client !== undefined && this.editedInvoice.client.id !== null) {
                        const client_id = this.editedInvoice.client.id;
                        if (this.editedInvoice.date !== null) {
                            body = {client_id: client_id, date: this.editedInvoice.date};
                        } else {
                            body = {client_id: client_id};
                        }
                    }
                    delete this.editedInvoice.client;
                    axios.post(process.env.API_URL + '/invoices', body)
                        .then((response) => {
                            this.closedSwitch = false;
                            this.invoices.unshift(response.data);
                            this.invoiceDialog = false;
                            this.$store.commit('displaySnackbar', 'Invoice Nº ' + response.data.id + ' created.');
                            this.getInvoiceInfo(response.data.id);
                            this.toggleInvoiceDialog()
                        })
                        .catch((error) => {
                            this.displayMessage('ERROR ' + error + '. ')
                        });

                    this.editedInvoice = Object.assign({}, this.defaultInvoice);
                }
            },
            // @vuese
            // Cancels invoice editing and resets relevant variables to default values
            cancel() {
                this.invoiceDialog = false;
                this.editInvoiceInfo = false;
                this.editedInvoice = Object.assign({}, this.defaultInvoice);
                // setTimeout(() => {
                //   this.editedInvoice = Object.assign({}, this.defaultInvoice);
                //   this.editedIndex = -1;
                // }, 300)
            }
            ,
            // @vuese
            // Toggles full screen dialog displaying each line of the invoice
            toggleInvoiceDialog() {
                this.invoiceDisplayerDialog = !this.invoiceDisplayerDialog;
            },
            // @vuese
            // Gets invoice and credit card information for the row the user just clicked
            // @arg Takes a RenderedInvoice Object as an argument
            invoiceSelected(props) {
                // props.expanded = !props.expanded;
                this.getInvoiceInfo(props.item.id);
                this.getCreditCardInfo(props.item.id);
            },
            // @vuese
            // Gets credit card information from a particular invoice by calling GET /invoices/{invoice_id}/creditnotes
            // @arg Takes invoice_id as an argument
            getCreditCardInfo(invoice_id) {
                axios.get(process.env.API_URL + '/invoices/' + invoice_id + '/creditnotes')
                    .then((response) => {
                        this.creditNoteInformation = response.data;
                    })
                    .catch((response) => {
                        // this.displayMessage('ERROR ' + response.response.data.error);
                    })
            },
            // @vuese
            // Gets invoice information from a particular invoice by calling GET /invoices/{invoice_id}
            // @arg Takes invoice_id as an argument
            getInvoiceInfo(invoice_id) {
                axios.get(process.env.API_URL + '/invoices/' + invoice_id)
                    .then((response) => {
                        if (response.status === 200) {
                            this.invoiceInformation = response.data;
                        } else {
                            this.displayMessage('ERROR ' + response.status + '. When getting Invoice Information');
                        }
                    })
                    .catch((response) => {
                        this.displayMessage('ERROR ' + response.response.data.error + '. When getting Invoice Information');
                    })
            },
            // @vuese
            // Copies the content of the item user tries to edit into editedItem variable and stores editedIndex
            // @arg Takes renderedInvoice Object as an argument
            editInvoice(props) {

                this.editedIndex = this.invoices.map((elt) => {
                    return elt.id
                }).indexOf(props.item.id);
                this.editedInvoice = Object.assign({}, props.item);
                props.expanded = true;
                // this.editInvoiceInfo = !this.editInvoiceInfo;

                if (this.editInvoiceInfo) {
                    this.cancel();
                } else {
                    this.editInvoiceInfo = true;
                }
            }
            ,
            // @vuese
            // Stores the item user wants to delete in toBeDeleted variable
            // @arg Takes the renderedInvoice Object user wants to delete as an argument
            displayDeleteMessage(item) {
                this.confirmDialog = true;
                this.toBeDeleted = item;
            }
            ,
            // @vuese
            // Displays PDF/HTML preview in a new tab
            // @arg Takes renderedInvoice Object as an argument
            displayPdfInvoice(item) {
                let extension = item.closed ? '/pdf' : '/html';
                window.open(process.env.API_URL + '/invoices/' + item.id + extension + '?key=' + encodeURI(this.$store.state.auth.key), '_blank')
            }
            ,
            // @vuese
            // Downloads PDF invoice file from the API
            // @arg Takes renderedInvoice Object as an argument
            downloadPdfInvoice(item) {
                this.loadingDownload = true;
                axios({
                    url: process.env.API_URL + '/invoices/' + item.id + '/pdf',
                    method: 'GET',
                    responseType: 'blob'
                })
                    .then((response) => {
                        if (response.status === 200) {
                            var url = URL.createObjectURL(response.data);
                            const link = document.createElement('a');
                            link.href = url;
                            link.setAttribute('download', 'Invoice ' + item.id + '.pdf');
                            document.body.appendChild(link);
                            link.click();
                        } else {
                            this.displayMessage('ERROR ' + response.status);
                        }
                        this.loadingDownload = false;
                    })
                    .catch((error) => {
                        this.displayMessage('ERROR ' + error);
                        this.loadingDownload = false;
                    })

            }
            ,
            // @vuese
            // Deletes the toBeDeleted invoice previously stored and posts the change on the API.
            deleteInvoice() {
                const index = this.invoices.indexOf(this.toBeDeleted);
                this.confirmDialog = false;
                axios.delete(process.env.API_URL + '/invoices/' + this.toBeDeleted.id, this.toBeDeleted)
                    .then((response) => {
                        if (response.status === 204) {
                            this.$store.commit('displaySnackbar', 'Invoice Nº' + this.invoices[index].id + ' deleted.');
                            this.invoices.splice(index, 1);
                        } else {
                            this.displayMessage('ERROR ' + response.status)
                        }
                    })
                    .catch((response) => {
                        this.displayMessage('ERROR ' + response.response.data.error);
                        // this.displayMessage('ERROR' + error.response.status + '. ' + error.response.data.error)
                    });
                this.toBeDeleted = null;
                this.editedIndex = -1;
                this.editedInvoice = Object.assign({}, this.defaultInvoice);
            }
            ,
            // @vuese
            // Stores the renderedInvoice Object user wants to close in toBeClosed variable and displays the close confirmation dialog
            // @arg Takes the renderedInvoice Object user wants to close as an argument.
            displayCloseMessage(item) {
                this.confirmCloseDialog = true;
                this.toBeClosed = item
            }
            ,
            // @vuese
            // Closes the toBeClosed renderedInvoice Object previously stored and post the changes through the API.
            // Sends as well the invoice by mail to the filled email address if provided.
            // @arg Takes a 'yes'/'no' string as an argument determining if we should send or not the freshly closed invoice.
            closeInvoice(str) {
                if (str === 'no') {
                    // User doesn't want to send invoice
                    axios.post(process.env.API_URL + '/invoices/' + this.toBeClosed.id + '/close')
                        .then((response) => {
                            Object.assign(this.invoices[this.invoices.indexOf(this.toBeClosed)], response.data);
                            this.confirmCloseDialog = false;
                        })
                        .catch((response) => {
                            this.displayMessage('ERROR ' + response.response.data.error);
                        })
                } else if (str === 'yes') {
                    let body = {};
                    if (this.emailTo !== null && this.emailTo.length > 0) {
                        // User filled an email
                        body = {send: true, to: this.emailTo}
                    } else {
                        body = {send: true}
                    }

                    axios.post(process.env.API_URL + '/invoices/' + this.toBeClosed.id + '/close', body)
                        .then((response) => {
                            Object.assign(this.invoices[this.invoices.indexOf(this.toBeClosed)], response.data);
                            this.confirmCloseDialog = false;
                        })
                        .catch((response) => {
                            this.displayMessage('ERROR ' + response.response.data.error);
                        });
                    this.emailTo = null;
                }
            },
            toggleExpand(row) {
                if (this.expanded.findIndex(x => x.id === row.id) === -1) {
                    this.expanded.push(row);
                } else {
                    this.expanded = this.expanded.filter(x => x.id !== row.id);
                }
            }
        }
    }
</script>

<style scoped>
.disabled {
  pointer-events: auto;
}
.column {
  background-color: #00a7d3;
}
.v-toolbar__content, .v-toolbar__extension {
  padding: 0px;
}
input {
  outline: 1px deepskyblue dotted;
}
.v-card__title {
  word-break: keep-all;
}
</style>



// WEBPACK FOOTER //
// src/components/util/Invoices/InvoicesDataTable.vue